{
  "loading": "Įkeliama...",
  "placeholder": "Pasirinkite…"
}
